import React, { useContext } from 'react';
import { Grid, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';

import ModalsContext from 'src/context/modals.jsx';

const PlacesTable = ({ fields, remove, update, img }) => {
	if (!fields?.length) return <></>;

	const modals_context = useContext(ModalsContext);

	return (
		<Grid item xs={12}>
			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell sx={{ pl: 3 }}>Name</TableCell>
							<TableCell align="left">Description</TableCell>
							<TableCell align="left">Coordinates</TableCell>
							<TableCell align="right" sx={{ pr: 3 }}>
								Actions
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{fields.map(({ name, x, y, desc }, index) => (
							<TableRow key={index}>
								<TableCell sx={{ pl: 3 }}>
									<Typography align="left" variant="subtitle1">
										{name}
									</Typography>
								</TableCell>

								<TableCell>
									<Typography align="left" variant="subtitle1">
										{desc}
									</Typography>
								</TableCell>

								<TableCell>
									<Typography align="left" variant="subtitle1">
										{x && y && `X: ${x}% Y: ${y}%`}
									</Typography>
								</TableCell>

								<TableCell sx={{ pr: 1 }} align="right">
									<Stack direction="row">
										<IconButton
											color="error"
											size="small"
											onClick={() =>
												modals_context.show('item_delete', {
													clb: () => remove(index),
												})
											}
										>
											<DeleteTwoToneIcon fontSize="small" />
										</IconButton>
										<IconButton
											color="secondary"
											size="large"
											onClick={() =>
												modals_context.show('maps_place_edit', {
													data: fields[index],
													clb: (data) => update(index, data),
													img,
												})
											}
										>
											<EditTwoToneIcon sx={{ fontSize: '1.3rem' }} />
										</IconButton>
									</Stack>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Grid>
	);
};

export default PlacesTable;
